import { render, staticRenderFns } from "./Format.vue?vue&type=template&id=1f40f4c9&scoped=true&"
import script from "./Format.vue?vue&type=script&lang=js&"
export * from "./Format.vue?vue&type=script&lang=js&"
import style0 from "./Format.vue?vue&type=style&index=0&id=1f40f4c9&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f40f4c9",
  null
  
)

export default component.exports